<template>
  <svg
    width="82"
    height="81"
    viewBox="0 0 82 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 11.0417L12.0417 0L40.75 28.7083L69.4583 0L80.5 11.0417L51.7917 39.75L80.5 68.4583L69.4583 79.5L40.75 50.7917L12.0417 79.5L1 68.4583L29.7083 39.75L1 11.0417Z"
      fill="#FE295F"
      stroke="#FE295F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconClose',
  }
</script>
